/* eslint-disable */
import React, { useLayoutEffect, useRef } from 'react';
import { TextInput } from '@trueprodigy/components';
import TextInputTest from './TextInputTest';
import { useSelector } from 'react-redux';
import { getCaseSettingData } from '@modules/appraisalAdmin/selectors/letterCaseSetting';

const TextInputWrapper = (props) => {
  const { input, ...rest } = props;
  const { onChange, value } = input;
  const caseSetting = useSelector(getCaseSettingData);
  const cursorRef = useRef(null);
  const ref = useRef(null);
  const isValidCaseInput = () => {
    const { type, disableCase } = props;

    return type !== 'date' && type !== 'time' && !disableCase;
  };
  useLayoutEffect(() => {
    if (props.InputProps) return;
    const input = ref.current;
    if (input && input.selectionStart) {
      input.selectionStart = cursorRef.current;
      input.selectionEnd = cursorRef.current;
    }
  }, [ref, cursorRef.current, value]);
  const onChangeHandler = (v, e) => {
    if (e && e.target) {
      cursorRef.current = e.target.selectionStart;
    }
    if (isValidCaseInput() && caseSetting === 'All Uppercase' && v && e) {
      e.persist && e.persist();
      if (typeof v === 'object') {
        v.value =
          v.value && v.value.toUpperCase ? v.value.toUpperCase() : v.value;
      } else {
        v = v && v.toUpperCase ? v.toUpperCase() : v;
      }
      return onChange(v);
    }
    return onChange(v);
  };
  if (props.numberMaskSetting) {
    return (
      <TextInputTest
        {...rest}
        inputRef={ref}
        input={{
          ...input,
          onChange: onChangeHandler,
        }}
      />
    );
  }
  return (
    <TextInput
      {...props}
      inputRef={ref}
      input={{
        ...input,
        onChange: onChangeHandler,
      }}
    />
  );
};

export default TextInputWrapper;
